import { Link } from 'react-router-dom';

export function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-brand-navy text-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h2 className="text-lg font-bold mb-3">B&amp;A Accounting Group Pty Ltd</h2>
            <p className="text-sm text-white/85 leading-relaxed">
              Toowoomba's accountants since 1981. Personalised accounting, tax and business services
              from experienced accountants who care.
            </p>
          </div>
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wide mb-3 text-white/90">Visit us</h3>
            <address className="text-sm text-white/85 not-italic leading-relaxed">
              105–107 Neil Street<br />
              Toowoomba, QLD 4350<br />
              Australia
            </address>
            <p className="text-sm text-white/85 mt-3">
              Mon–Fri 8:30 AM – 5:00 PM<br />
              <span className="text-white/70">Closed weekends &amp; public holidays</span>
            </p>
          </div>
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wide mb-3 text-white/90">Get in touch</h3>
            <p className="text-sm text-white/85">
              <a href="tel:+61746323155" className="hover:underline">(07) 4632 3155</a>
            </p>
            <p className="text-sm text-white/85 mt-1">
              <a href="mailto:admin@ba-accounting.com.au" className="hover:underline">admin@ba-accounting.com.au</a>
            </p>
            <nav className="mt-5 flex flex-col gap-2 text-sm" aria-label="Footer">
              <Link to="/about" className="text-white/85 hover:text-white">About us</Link>
              <Link to="/services" className="text-white/85 hover:text-white">Our services</Link>
              <Link to="/contact" className="text-white/85 hover:text-white">Contact</Link>
            </nav>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/15 flex flex-col md:flex-row gap-3 md:items-center md:justify-between text-xs text-white/65">
          <p>© {year} B&amp;A Accounting Group Pty Ltd. All rights reserved.</p>
          <p className="md:text-right">Liability limited by a scheme approved under Professional Standards Legislation.</p>
        </div>
      </div>
    </footer>
  );
}
